import { render, staticRenderFns } from "./TagsGenerate.vue?vue&type=template&id=173b585b"
import script from "./TagsGenerate.vue?vue&type=script&lang=js"
export * from "./TagsGenerate.vue?vue&type=script&lang=js"
import style0 from "./TagsGenerate.vue?vue&type=style&index=0&id=173b585b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports